import { render, staticRenderFns } from "./SearchResultTable.vue?vue&type=template&id=8fdbaf58"
import script from "./SearchResultTable.vue?vue&type=script&lang=js"
export * from "./SearchResultTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports